import {combineReducers} from 'redux';
import {reducer as formReducer} from 'redux-form';
import {routerReducer} from './middlewares';
import {rehydrate} from '../common/rehydrate';
import {Session} from './actionTypes';
import {messageBox} from './messageBox/reducers';
import {session} from '../session/reducers';
import {menu} from './menu/reducers';
import {provider} from '../provider/reducers';
import {origin} from '../origin/reducers';
import {parameters} from '../parameter/reducers';
import {order} from '../order/reducers';
import {obsolescenceParameters} from '../obsolescenceParameters/reducers';
import {providerConfiguration} from '../providerConfiguration/reducers';
import {dailyVehiclesSalesAndStockSummary} from '../dailyVehiclesSalesAndStockSummary/reducers';
import {dailyVehiclesSalesAndStockWholesale} from '../dailyVehiclesSalesAndStockWholesale/reducers';
import {dailyVehiclesSalesAndStock} from '../dailyVehiclesSalesAndStock/reducers';
import {excelReader} from '../excelReader/reducers';
import {monthClose} from '../monthClose/reducers';
import {backOrders} from '../backOrders/reducers';
import {itemBudget} from '../itemBudget/reducers';
import {partsMaster} from '../partsMaster/reducers';
import {providerOrders} from '../providerOrders/reducers';
import {lubricantsInvoicing} from '../lubricants/reducers';
import {salesAndBudgetsLoad} from '../salesAndBudgetsLoad/reducers';
import {vehicleEfficiency} from '../vehicleEfficiency/reducers';
import {stockAdjustments} from '../stockAdjustment/reducers';
import {vehicleHistory} from '../vehicleHistory/reducers';
import {partQuotation} from '../partQuotation/reducers';
import {invoicesQuery} from '../invoiceQuery/reducers';
import {specialParts} from '../specialParts/reducers';
import {partsCatalog} from '../partsCatalog/reducers';
import {vehiclesKpi} from '../vehiclesKpi/reducers';
import {partsSales} from '../partsSales/reducers';
import {partAudit} from '../partAudit/reducers';
import {masterVehicle, masterVehicleImages} from '../masterVehicle/reducers';
import {iccmatrix} from '../iccMatrix/reducers';
import {transport} from '../transport/reducers';
import {dealer} from '../dealer/reducers';
import {users} from '../user/reducers';
import Kpis from '../kpis/reducers';
import Liquidations from '../liquidations/reducers';
import Sets from '../sets/reducers';
import Icc from '../iccChart/reducers';
import Accessories from '../accessories/reducers';
import formsFTR from '../forms/reducers';
import BoReport from '../boReport/reducers';
import WaitHappy from '../waitHappy/reducers';
import Campaign from '../campaign/reducers';
import WholeSale from '../wholeSale/reducers';
import CalendarTems from '../calendar/reducers';
import PriceFactors from '../priceFactors/reducers';
import PartInvoices from '../partInvoices/reducers';
import TwcMaintenance from '../twcMaintenance/reducers';
import budgetsVehicles from '../budgetVehicles/reducers';
import vehicleSaleForecast from '../vehicleSaleForecast/reducers';
import DealerOrders from '../dealerOrders/reducers';
import PartsReturns from '../partsReturns/reducers';
import VehicleCombos from '../vehicleCombos/reducers';
import partNumberCode from '../partNumberCode/reducers';
import LogisticsReports from '../logisticsReports/reducers';
import VehiclesAvailability from '../vehiclesAvailability/reducers';
import QualityAssuranceOrders from '../qualityAssuranceOrders/reducers';
import ServiceReportPart from '../serviceReportPart/reducers';
import LogisticsOrders from '../logisticsOrders/reducers';
import ProcessedWarranty from '../twcConsulty/reducers';
import WarrantiesAdmin from '../adminWarranty/reducers';
import Warranties from '../warranties/reducers';
import VehAudi from '../vehAudi/reducers';
import Binning from '../binning/reducers';
import Warehouse from '../warehouses/reducers';
import Part from '../part/reducers';
import Picking from '../picking/reducers';
import VehicleCertification from '../vehicleCertification/reducers';
import AnticipatedInvoiceVehicles from '../anticipatedInvoiceVehicles/reducers';
import DispatchOrders from '../dispatchOrders/reducers';
import DevicesOrder from '../devices/reducers';
import ManageOrders from '../manageOrders/reducers';
import VehiclesInventory from '../vehiclesInventory/reducers';
import PartsImports from '../partsImports/reducers';
import Bulletins from '../bulletins/reducers';
import Users from '../users/reducers';
import MailGroup from '../mailGroup/reducers';
import AccessoriesRequests from '../accessoriesRequests/reducers';
import CombosReducers from '../combos/reducers';
import TranportistReducers from '../transportist/reducers';
import AgenciesReducers from '../agencies/reducers';
import LogisticModelsReducers from '../logisticModels/reducers';
import LogisticTasksReducers from '../logisticTasks/reducers';
import VehiclesPriorization from '../vehiclesPriorization/reducers';
import LogisticAreas from '../logisticAreas/reducers';
import Technicians from '../logisticTechnicians/reducers';
import FloatingInventory from '../floatingInventory/reducers';
import * as Forms from './forms';
import CustomerTracking from '../customerTracking/reducers';
import CommercialUsers from '../commercialUsers/reducers';
import AccountReporter from '../accountReporter/reducers';
import Wts from '../wts/reducers';
import ReportPartsSalesJapanData from '../reportPartsSalesJapan/reducers';
import PartsLocationDashboard from '../partsLocationDashboard/reducers';

const coreReducers = [
  {messageBox},
  {'router': routerReducer},
  {rehydrate},
  {session},
  {menu},
  {origin},
  {provider},
  {parameters},
  {order},
  ...providerConfiguration,
  ...stockAdjustments,
  {excelReader},
  {monthClose},
  {backOrders},
  {itemBudget},
  {partsMaster},
  {lubricantsInvoicing},
  {salesAndBudgetsLoad},
  {obsolescenceParameters},
  {dailyVehiclesSalesAndStock},
  {dailyVehiclesSalesAndStockSummary},
  {dailyVehiclesSalesAndStockWholesale},
  {vehicleEfficiency},
  {vehicleHistory},
  {partQuotation},
  {invoicesQuery},
  {specialParts},
  {...budgetsVehicles},
  {...vehicleSaleForecast},
  {partsCatalog},
  {vehiclesKpi},
  {partsSales},
  {partAudit},
  {masterVehicle},
  {iccmatrix},
  {masterVehicleImages},
  {transport},
  {dealer},
  {users},
  {...formsFTR},
  {...Kpis},
  {...Liquidations},
  {...Icc},
  {...Sets},
  {...Users},
  {...BoReport},
  {...MailGroup},
  {...Accessories},
  {...CalendarTems},
  {...PriceFactors},
  {...DealerOrders},
  {...PartInvoices},
  {...PartsReturns},
  {...Binning},
  {...Part},
  {...Bulletins},
  {...VehAudi},
  {...Picking},
  {...Campaign},
  {...WholeSale},
  {...Warehouse},
  {...WaitHappy},
  {...Warranties},
  {...WarrantiesAdmin},
  {...VehicleCombos},
  {...LogisticsOrders},
  {...providerOrders},
  {...partNumberCode},
  {...TwcMaintenance},
  {...LogisticsReports},
  {...ProcessedWarranty},
  {...ServiceReportPart},
  {...VehiclesAvailability},
  {...QualityAssuranceOrders},
  {...VehicleCertification},
  {...AnticipatedInvoiceVehicles},
  {...DispatchOrders},
  {...DevicesOrder},
  {...ManageOrders},
  {...VehiclesInventory},
  {...DevicesOrder},
  {...PartsImports},
  {...AccessoriesRequests},
  {...CombosReducers},
  {...TranportistReducers},
  {...AgenciesReducers},
  {...VehiclesPriorization},
  {...CustomerTracking},
  {...Technicians},
  {...LogisticAreas},
  {...FloatingInventory},
  {...LogisticModelsReducers},
  {...LogisticTasksReducers},
  {...CommercialUsers},
  {...AccountReporter},
  {...Wts},
  {...ReportPartsSalesJapanData},
  {...PartsLocationDashboard},
];

const formReducers = {
  [Forms.ORIGIN.name]: Forms.ORIGIN.reducer,
  [Forms.PROVIDER.name]: Forms.PROVIDER.reducer,
  [Forms.PARAMETERS_FORM.name]: Forms.PARAMETERS_FORM.reducer,
  [Forms.PART.name]: Forms.PART.reducer,
  [Forms.TRANSFER_FORM.name]: Forms.TRANSFER_FORM.reducer,
  [Forms.WAREHOUSE_DENIAL_CAUSE_FORM.name]:
    Forms.WAREHOUSE_DENIAL_CAUSE_FORM.reducer,
  [Forms.SHIFT_FORM.name]: Forms.SHIFT_FORM.reducer,
  [Forms.ZONE_FORM.name]: Forms.ZONE_FORM.reducer,
  [Forms.SCANNING_FORM.name]: Forms.SCANNING_FORM.reducer,
  [Forms.SCANNING_WAREHOUSE_DENIED_FORM.name]:
    Forms.SCANNING_WAREHOUSE_DENIED_FORM.reducer,
  [Forms.INVOICE.name]: Forms.INVOICE.reducer,
  [Forms.ICC_CATEGORIES_PARAMETERS.name]:
    Forms.ICC_CATEGORIES_PARAMETERS.reducer,
  [Forms.ICC_MAD_PARAMETERS.name]: Forms.ICC_MAD_PARAMETERS.reducer,
  [Forms.CHECKING_FORM.name]: Forms.CHECKING_FORM.reducer,
  [Forms.INVOICING_FORM.name]: Forms.INVOICING_FORM.reducer,
  [Forms.MANAGE_COLORS_FORM.name]: Forms.MANAGE_COLORS_FORM.reducer,
  [Forms.STOCK_ADJUSTMENT_FORM.name]: Forms.STOCK_ADJUSTMENT_FORM.reducer,
  [Forms.QUALITY_ASSURANCE_ORDERS_FORM.name]:
    Forms.QUALITY_ASSURANCE_ORDERS_FORM.reducer,
  [Forms.TECHNICIAN_ASSIGNMENT_FORM.name]:
    Forms.TECHNICIAN_ASSIGNMENT_FORM.reducer,
  [Forms.MASTER_VEHICLE_FORM.name]: Forms.MASTER_VEHICLE_FORM.reducer,
  [Forms.DISPATCH_ORDER_FORM.name]: Forms.DISPATCH_ORDER_FORM.reducer,
  [Forms.ERROR_CODES_FORM.name]: Forms.ERROR_CODES_FORM.reducer,
  [Forms.TASKS_CODES_FORM.name]: Forms.TASKS_CODES_FORM.reducer,
  [Forms.USER_FORM.name]: Forms.USER_FORM.reducer,
  [Forms.MAIL_GROUP_FORM.name]: Forms.MAIL_GROUP_FORM.reducer,
  [Forms.ADVISOR_MANAGEMENT_FORM.name]: Forms.ADVISOR_MANAGEMENT_FORM.reducer,
  [Forms.EXEMPTION_MANAGEMENT_FORM.name]:
    Forms.EXEMPTION_MANAGEMENT_FORM.reducer,
  [Forms.CLIENT_MANAGEMENT_FORM.name]: Forms.CLIENT_MANAGEMENT_FORM.reducer,
};

const generateCombinedReducers = (customReducers) => {
  const rootFormReducer = {'form': formReducer.plugin(formReducers)};
  if (customReducers instanceof Array) {
    return combineReducers(
      Object.assign({}, rootFormReducer, ...customReducers, ...coreReducers)
    );
  }
  return combineReducers(
    Object.assign({}, rootFormReducer, customReducers, ...coreReducers)
  );
};

const generateReducers = (customReducers) => {
  const internalReducers = generateCombinedReducers(customReducers);
  return (state, action) => {
    if (action && action.type === Session.USER_LOGOUT) {
      state = undefined; // eslint-disable-line
    }
    return internalReducers(state, action);
  };
};

export default generateReducers;
